'use client';

import { useState } from 'react';

import classnames from 'classnames';
import { getDay } from 'date-fns';
import { IoCalendarOutline } from 'react-icons/io5';

import type { BaseComponentProps } from '../../base-component.types';
import { DateCalendar } from '../../date-calendar';
import { Icon } from '../../icon';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../tooltip';
import { useDateStreakContext } from '../DateStreak';

import styles from './DateStreakCalendar.module.scss';

type DateStreakCalendarProps = BaseComponentProps & {};

const isWeekday = (date: Date): boolean => {
  const day = getDay(date);
  return day !== 0;
};

function DateStreakCalendar({ style, className }: DateStreakCalendarProps) {
  const context = useDateStreakContext();
  const [open, setOpen] = useState(false);

  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger
        onClick={() => setOpen((v) => !v)}
        asChild={true}
        className={classnames(
          styles['date-streak-calendar__trigger'],
          className,
        )}
        style={style}
      >
        <Icon icon={<IoCalendarOutline />} size="sm" />
      </TooltipTrigger>
      <TooltipContent>
        <DateCalendar
          className={styles['date-streak-calendar__content']}
          highlightedDates={context.highlightedDates}
          excludeDates={context.disabledDates}
          specialDates={context.skippedDates}
          locale={context.locale}
          filterDate={isWeekday}
        />
      </TooltipContent>
    </Tooltip>
  );
}

export { DateStreakCalendar };
